import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { DataProvider } from "@/context/DataContext";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { LiveBanner } from "@/components/layout/LiveBanner";
import { Toaster } from "@/components/ui/sonner";
import { ErrorBoundary } from "@/components/shared/ErrorBoundary";
import { NewsletterModal } from "@/components/newsletter/NewsletterModal";

import Home from "@/pages/Home";
import Nyheter from "@/pages/Nyheter";
import Tavlingsinformation from "@/pages/Tavlingsinformation";
import Dokument from "@/pages/Dokument";
import ForForare from "@/pages/ForForare";
import Publik from "@/pages/Publik";
import Partners from "@/pages/Partners";
import Historia from "@/pages/Historia";
import Kontakt from "@/pages/Kontakt";
import Admin from "@/pages/Admin";
import DepaBokning from "@/pages/DepaBokning";
import Anslagstavla from "@/pages/Anslagstavla";
import Videor from "@/pages/Videor";
import AnslagstavlaLive from "@/pages/AnslagstavlaLive";
import TavlaAdmin from "@/pages/TavlaAdmin";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function PublicLayout({ children }) {
  return (
    <>
      <LiveBanner />
      <Navbar />
      <main><ErrorBoundary>{children}</ErrorBoundary></main>
      <Footer />
      <NewsletterModal />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <DataProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route path="/admin" element={<Admin />} />
              <Route path="/tavla-admin" element={<TavlaAdmin />} />
              <Route path="/anslagstavla/live" element={<AnslagstavlaLive />} />
              <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
              <Route path="/nyheter" element={<PublicLayout><Nyheter /></PublicLayout>} />
              <Route path="/tavlingsinformation" element={<PublicLayout><Tavlingsinformation /></PublicLayout>} />
              <Route path="/dokument" element={<PublicLayout><Dokument /></PublicLayout>} />
              <Route path="/for-forare" element={<PublicLayout><ForForare /></PublicLayout>} />
              <Route path="/publik" element={<PublicLayout><Publik /></PublicLayout>} />
              <Route path="/partners" element={<PublicLayout><Partners /></PublicLayout>} />
              <Route path="/historia" element={<PublicLayout><Historia /></PublicLayout>} />
              <Route path="/kontakt" element={<PublicLayout><Kontakt /></PublicLayout>} />
              <Route path="/depa-bokning" element={<PublicLayout><DepaBokning /></PublicLayout>} />
              <Route path="/anslagstavla" element={<PublicLayout><Anslagstavla /></PublicLayout>} />
              <Route path="/videor" element={<PublicLayout><Videor /></PublicLayout>} />
            </Routes>
            <Toaster position="top-center" theme="dark" richColors />
          </BrowserRouter>
        </DataProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
